export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/metronome-icon.svg?9bb8edff54f1c5f654940ac123f2c181";